const accordionGroup = (): void => {
  // console.log('accordionGroup');
};

export default accordionGroup;
